<div *ngIf="show" class="cookies-alert" >
    <span class="close-cookies" (keydown.enter)="close()"  (click)="close()" aria-label="סגור חלון עוגיות"  role="button" tabindex="0"></span>
    <span class="message">
        <span class="bold">לידיעתך: </span><span>אנחנו משתמשים בעוגיות באתר זה</span>
        <a href="{{link}}/he-il/GeneralPages/Pages/ShimushBeCookies.aspx?sourceGA=CookiePopup" target="_blank" class="more-details"> לפרטים נוספים </a>
    </span>
</div>
